// T024 — Proposal field constraints config.
// All form validation reads from this config rather than hardcoding requirements.

export const PROPOSAL_FIELDS = {
  title: {
    required: true,
    minLength: 5,
    maxLength: 200,
  },
  // Ticker limits and their combined budget count UTF-8 bytes.
  marketTicker: {
    required: true,
    minLength: 3,
    maxLength: 18,
    pattern: /^[^\p{White_Space}\p{Cc}\p{Cs}]+$/u,
  },
  description: {
    required: false,
    minLength: 0,
    maxLength: 2000,
  },
  category: {
    required: true,
  },
  location: {
    required: true,
  },
  coverImage: {
    required: false,
  },
  // Outcome labels are token names when appended: at most 32 UTF-8 bytes.
  outcomes: {
    labelMinLength: 1,
    labelMaxLength: 32,
    imageUrlMaxLength: 256,
  },
  outcomeTicker: {
    required: true,
    minLength: 1,
    maxLength: 10,
    pattern: /^[^\p{White_Space}\p{Cc}\p{Cs}]+$/u,
  },
  tickerCombined: {
    maxLength: 20,
  },
  backerFund: {
    minD6: 10_000_000, // $10 minimum
  },
} as const;

export type ProposalFieldsConfig = typeof PROPOSAL_FIELDS;
